//@flow
import { connect } from 'react-redux';
import SuspendSwapTerminateSuccess from './SuspendSwapTerminateSuccess.container';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';

import type { StateProps } from '../../components/SuccessPage/SuccessPage';
import { customerEmailSelector } from '../../modules/Customer/selectors';
import type { StateType } from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  successImage: theme.wellDoneImage,
  successTitle: I18n.t('SignUp.SwapSim.order.successTitle', {
    customerEmail: customerEmailSelector(state),
  }),
  confirmButtonText: I18n.t('SignUp.SwapSim.successButton'),
  withGradient: true,
});

export default connect(mapStateToProps)(SuspendSwapTerminateSuccess);
